import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'tmwFilterBy',
  pure: false,
})
export class TmwFilterPipe implements PipeTransform {
  transform(array: any[], filter: any): any {
    if (!array || !filter) {
      return array;
    }

    // If filter is a string, treat it as the term and perform filtering without specifying a field
    if (typeof filter === 'string') {
      const termUpper = filter.toUpperCase();
      return array.filter((item) => {
        for (const key in item) {
          if (Object.prototype.hasOwnProperty.call(item, key)) {
            const fieldValue = item[key];
            if (fieldValue && fieldValue.toString().toUpperCase().includes(termUpper)) {
              return true;
            }
          }
        }
        return false;
      });
    }

    const termUpper = filter.term ? filter.term.toString().toUpperCase() : '';

    return array.filter((item) => {
      if (filter.field) {
        const fieldValue = item[filter.field];
        return fieldValue && fieldValue.toString().toUpperCase().includes(termUpper);
      } else {
        for (const key in item) {
          if (Object.prototype.hasOwnProperty.call(item, key)) {
            const fieldValue = item[key];
            if (fieldValue && fieldValue.toString().toUpperCase().includes(termUpper)) {
              return true;
            }
          }
        }
        return false;
      }
    });
  }
}
